import React from 'react';

/** Evita a tela branca quando um erro de render escapa. */
export default class AppErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { falhou: false };
  }

  static getDerivedStateFromError() {
    return { falhou: true };
  }

  render() {
    if (this.state.falhou) {
      return (
        <div style={{ padding: 32, maxWidth: 480, margin: '10vh auto', fontFamily: 'sans-serif', textAlign: 'center' }}>
          <h2 style={{ marginBottom: 8 }}>Não foi possível exibir esta tela</h2>
          <p style={{ color: '#555' }}>
            Atualize a página. Se estava excluindo um cadastro, ele pode estar vinculado a outros registros e não pode ser apagado.
          </p>
          <button type="button" onClick={() => window.location.reload()} style={{ marginTop: 16, padding: '8px 16px' }}>
            Atualizar
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
